export const waitForElement = (
  locator: () => HTMLElement | null,
  maxAttempts = 1000,
  interval = 10
) => {
  return new Promise((resolve, reject) => {
    let attempts = 0;

    const check = () => {
      const element = locator();
      if (element) {
        resolve(element);
      } else if (attempts >= maxAttempts) {
        reject(new Error("Element not found"));
      } else {
        attempts++;
        setTimeout(check, interval);
      }
    };

    check();
  });
};
